module.exports = __webpack_public_path__ + "img/injectionsteps_step10.6d827861.png";